// ── RouteLogo — shared brand SVG component ───────────────────────────────────

interface RouteLogoProps {
  className?: string;
}

/**
 * Full Route wordmark (ROUTE letters).
 */
export const RouteLogo = ({ className }: RouteLogoProps) => (
  <svg viewBox="0 0 2705.1 1080" className={className} aria-label="Route Academy">
    <path d="M473.1,252c0-134.2-108.8-243-243-243H-12.9v1062h162v-333h81c44.73,0,81,36.27,81,81v252h162v-252c0-62.24-23.41-119.01-61.9-162,38.48-42.99,61.9-99.76,61.9-162v-243ZM149.1,576V171h81c44.73,0,81,36.27,81,81v243c0,44.74-36.27,81-81,81h-81Z" />
    <path d="M968.93,71.17C924.95,27.2,864.2,0,797.1,0c-134.21,0-243,108.79-243,243v106.05l162-93.53,162-93.53v675c0,44.73-36.27,81-81,81s-81-36.27-81-81v-394.42l-162,93.53v300.89c0,134.21,108.79,243,243,243s243-108.79,243-243V243c0-67.1-27.2-127.85-71.17-171.83Z" />
    <path d="M1445.1,9v828c0,44.73-36.27,81-81,81s-81-36.27-81-81V9h-162v828c0,134.21,108.79,243,243,243s243-108.79,243-243V9h-162Z" />
    <polygon points="1688.1 9 1688.1 171 1850.1 171 1850.1 1071 2012.1 1071 2012.1 171 2174.1 171 2174.1 9 1688.1 9" />
    <polygon points="2705.1 171 2705.1 9 2295.36 9 2295.36 9 2255.1 9 2255.1 1071 2417.1 1071 2417.1 1071 2705.1 1071 2705.1 909 2417.1 909 2417.1 623.39 2655.93 623.39 2655.93 461.39 2417.1 461.39 2417.1 171 2705.1 171" />
  </svg>
);

/**
 * The iconic 'O' (zero) mark — standalone brand icon.
 */
export const RouteOIcon = ({ className }: RouteLogoProps) => (
  <svg viewBox="0 0 486.3 1080" className={className} aria-label="Route Academy icon">
    <path d="M415.08,71.22C371.08,27.21,310.3,0,243.15,0,108.86,0,0,108.86,0,243.15v106.12l162.1-93.59,162.1-93.59v675.42c0,44.76-36.29,81.05-81.05,81.05s-81.05-36.29-81.05-81.05v-394.66L0,536.44v301.07C0,971.81,108.86,1080.67,243.15,1080.67s243.15-108.86,243.15-243.15V243.15c0-67.15-27.21-127.93-71.22-171.93Z" />
  </svg>
);
